import { useContext } from 'react';

import { PlatformContext } from './PlatformContext';
import type { Platform } from './types';

export function usePlatform(): Platform {
  const context = useContext(PlatformContext);

  if (!context) {
    throw new Error('usePlatform должен вызываться внутри PlatformProvider');
  }

  return context;
}
